export const DEFAULT_COVER = require('../assets/images/default-cover.png');
